// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IIndexFolder {
  name: string;
}
